import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class EmberGuard extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'emberGuard')

    this.maxHealth = 85
    this.health = 85
    this.damage = PLAYER_DAMAGE.STANDARD
    this.moveSpeed = 3
    this.attackRange = 1.5
    this.attackCooldown = 1.8
    this.detectionRange = 15
    this.knockbackResistance = 0.6
    this.blockChance = 0.25
  }

  takeDamage(amount) {
    if (Math.random() < this.blockChance) {
      amount *= 0.5
      this.flashTimer = 0.05
    }
    return super.takeDamage(amount)
  }

  dropLoot() {
    if (Math.random() < 0.35) {
      this.game.itemManager.spawnItem({
        type: 'potion',
        id: 'health_potion',
        name: 'Health Potion',
        healAmount: 50,
        count: 1
      }, { x: this.x, y: this.y })
    }
  }
}
